<template>
  <div data-view="groove-widget">
    <component :is="'layout-logged-frame'" :has-aside="false">
      <template v-slot:content>
        <v-row class="form-wrapper normal">
          <h2>Groove Widget testing page</h2>
        </v-row>
      </template>
    </component>
  </div>
</template>

<script>
  import setGrooveDisplayStyle from '../../utils/groove-widget';

  export default {
    beforeMount() {
      window.groove.widget = window.groove.createWidget();
      window.groove.widget.init('dc5b458e-d2ca-4fe1-b86d-0ffb0adfa2c3', {});

      setGrooveDisplayStyle();
    },
    beforeUnmount() {
      setGrooveDisplayStyle('none');
    },
  };
</script>

<style lang="scss" scoped>
[data-view='groove-widget'] {
  .layout.form-wrapper {
    height: calc(100vh - 250px);
    justify-content: center;
    align-items: center;
  }
}
</style>
